import { AndroidInterface } from "@/apps/credit-line/services/android.service";

declare const Android: AndroidInterface;

export const getDeviceTagHelper = (): string => {
  if (Android) {
    return Android.getDeviceTag();
  }
  return "";
};
